$(document).ready(function () {
    /********* On scroll heder Sticky *********/
    $(window).scroll(function () {
        var scroll = $(window).scrollTop();
        if (scroll >= 50) {
            $("header").addClass("head-sticky");
            $(".left-fixed-header").fadeOut();
        } else {
            $("header").removeClass("head-sticky");
            $(".left-fixed-header").fadeIn();
        }
    });
    /********* Mobile Menu ********/
    $('.mobile-menu-button').on('click', function (e) {
        e.preventDefault();
        setTimeout(function () {
            $('body').addClass('no-scroll active-menu');
            $(".mobile-menu-wrapper").toggleClass("active-menu");
            $('.overlay').addClass('menu-overlay');
        }, 50);
    });
    $('body').on('click', '.overlay.menu-overlay, .menu-close-icon svg', function (e) {
        e.preventDefault();
        $('body').removeClass('no-scroll active-menu');
        $(".mobile-menu-wrapper").removeClass("active-menu");
        $('.overlay').removeClass('menu-overlay');
    });
    /********* Cart Popup ********/
    $('.cart-header').on('click', function (e) {
        e.preventDefault();
        setTimeout(function () {
            $('body').addClass('no-scroll cartOpen');
            $('.overlay').addClass('cart-overlay');
        }, 50);
    });
    $('body').on('click', '.overlay.cart-overlay, .closecart', function (e) {
        e.preventDefault();
        $('.overlay').removeClass('cart-overlay');
        $('body').removeClass('no-scroll cartOpen');
    });
    /********* Mobile Filter Popup ********/
    $('.filter-title').on('click', function (e) {
        e.preventDefault();
        setTimeout(function () {
            $('body').addClass('no-scroll filter-open');
            $('.overlay').addClass('active');
        }, 50);
    });
    $('body').on('click', '.overlay.active, .close-filter', function (e) {
        e.preventDefault();
        $('.overlay').removeClass('active');
        $('body').removeClass('no-scroll filter-open');
    });
    /******* Cookie Js *******/
    $('.cookie-close').click(function () {
        $('.cookie').slideUp();
    });
    /******* Subscribe popup Js *******/
    $('.close-sub-btn').click(function () {
        $('.subscribe-popup').slideUp();
        $(".subscribe-overlay").removeClass("open");
    });
    /********* qty spinner ********/
    var quantity = 0;
    $('.quantity-increment').click(function () {
        ;
        var t = $(this).siblings('.quantity');
        var quantity = parseInt($(t).val());
        $(t).val(quantity + 1);
    });
    $('.quantity-decrement').click(function () {
        var t = $(this).siblings('.quantity');
        var quantity = parseInt($(t).val());
        if (quantity > 1) {
            $(t).val(quantity - 1);
        }
    });
    /********* qty spinner second ********/
    var quantity = 0;
    $('.quantity-increment').click(function () {
        ;
        var t = $(this).parent().siblings('.quantity');
        var quantity = parseInt($(t).val());
         $(t).val(quantity + 1 ) ;
    });
    $('.quantity-decrement').click(function () {
        var t = $(this).parent().siblings('.quantity');
        var quantity = parseInt($(t).val());
        if (quantity > 1) {
            $(t).val(quantity - 1) ;
        }
    });
  /*****  STEPPY FORM  CSS  *****/
var totalSteps = $(".steps li").length;
$(".submit").on("click", function(){
  return false; 
});

$(".steps li:nth-of-type(1)").addClass("active");
$(".myContainer .step-container:nth-of-type(1)").addClass("active");

$(".step-container").on("click", ".next", function() { 
  $(".steps li").eq($(this).parents(".step-container").index() + 1).addClass("active"); 
  $(this).parents(".step-container").removeClass("active").next().addClass("active"); 
  $('.right-slider').slick('refresh');  
});

$(".step-container").on("click", ".back", function() {  
  $(".steps li").eq($(this).parents(".step-container").index() - totalSteps).removeClass("active"); 
  $(this).parents(".step-container").removeClass("active").prev().addClass("active"); 
  $('.right-slider').slick('refresh');
}); 
    /*********  Multi-level accordion nav  ********/
    $('.acnav-label').click(function () {
        var label = $(this);
        var parent = label.parent('.has-children');
        var list = label.siblings('.acnav-list');
        if (parent.hasClass('is-open')) {
            list.slideUp('fast');
            parent.removeClass('is-open');
        }
        else {
            list.slideDown('fast');
            parent.addClass('is-open');
        }
    });
    // add active  
    $('.main-links li').click(function () {
        $('.main-links li').removeClass('active');
        $(this).addClass('active');
    })

    $('.play-vid1').on('click',function(){
        if($(this).attr('data-click') == 1) {
        $(this).attr('data-click', 0)
        $('.img-vid1')[0].pause();
        $(".play-vid1").css("opacity", "1");
        } else {
        $(this).attr('data-click', 1)
        $('.img-vid1')[0].play();
        $(".play-vid1").css("opacity", "1");
        $(".play-vid1").css("opacity", "0");
        }
    });
    $('.play-vid2').on('click',function(){
        if($(this).attr('data-click') == 1) {
        $(this).attr('data-click', 0)
        $('.img-vid2')[0].pause();
        $(".play-vid2").css("opacity", "1");
        } else {
        $(this).attr('data-click', 1)
        $('.img-vid2')[0].play();
        $(".play-vid2").css("opacity", "1");
        $(".play-vid2").css("opacity", "0");
        }
    });

    // video tab 
    $('.remote-button').click(function() {
        var tab_id = $(this).attr('data-tab');
    
        $('.remote-button').removeClass('current');
        $('.video-single').removeClass('current');
    
        $(this).addClass('current');
        $("#" + tab_id).addClass('current');

      });

    /****  TAB Js ****/
    $('ul.tabs li').click(function () {
        var $this = $(this);
        var $theTab = $(this).attr('data-tab');
        console.log($theTab);
        if ($this.hasClass('active')) {
            // do nothing
        } else {
            $this.closest('.tabs-wrapper').find('ul.tabs li, .tabs-container .tab-content').removeClass('active');
            $('.tabs-container .tab-content[id="' + $theTab + '"], ul.tabs li[data-tab="' + $theTab + '"]').addClass('active');
        }
        $('.blog-tab-slider').slick('refresh');
    });

    $('.tabs-nav ul li').click(function(){
        var currentTabIndex = $(this).index();
        var tabsContainer = $(this).closest('.tabs');
        var tabsNav = $(tabsContainer).children('.tabs-nav').children('ul').children('li');
        var tabsContent = $(tabsContainer).children('.tabs-content').children('div'); 
        
        $(tabsNav).removeClass('active');
        $(this).addClass('active');
        
        $(tabsContent).removeClass('active');
        $(tabsContent).eq(currentTabIndex).addClass('active');
        $('.product-tab-slider').slick('refresh');
        })

        $('.play-btn1').click(function (m) { 
            $('body,html').addClass('no-scroll popupopen');
            $('.overlay-popup-1').addClass('popup-show');
        });  
        $('.close-popup').click(function (m) { 
            $('body,html').removeClass('no-scroll popupopen');  
            $('.overlay-popup-1').removeClass('popup-show');
        });  

       $('.play-btn2').click(function (m) { 
            $('body,html').addClass('no-scroll popupopen');
            $('.overlay-popup-2').addClass('popup-show');
        });  
        $('.close-popup').click(function (m) { 
            $('body,html').removeClass('no-scroll popupopen');  
            $('.overlay-popup-2').removeClass('popup-show');
        });  

    // tab slider 
    $('.blog-tab-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        speed: 800,
        responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 500,
              settings: {
                slidesToShow: 1,
              }
            }
        ]
    }); 

    // review slider 
    $('.review-slider ').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 800,
        centerMode:true,
        responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                centerMode:false,
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                centerMode:false,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                centerMode:false,
              }
            },
            {
              breakpoint: 500,
              settings: {
                slidesToShow: 1,
                centerMode:false,
              }
            }
        ]
    }); 
 
     // client-logo-slider
     $('.client-logo-slider').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        speed: 800,
        autoPlay:true,
        centerMode:true,
        responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 4,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 575,
              settings: {
                slidesToShow: 1,
              }
            }
        ]
    }); 


     // blog-slider
     $('.blog-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        speed: 800,
        responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 500,
              settings: {
                slidesToShow: 1,
              }
            }
        ]
    }); 


if ($(".my-acc-column").length > 0) {
    jQuery(function ($) {
        var topMenuHeight = $("#daccount-nav").outerHeight();
        $("#account-nav").menuScroll(topMenuHeight);
        $(".account-list li:first-child").addClass("active");
    });
    // COPY THE FOLLOWING FUNCTION INTO ANY SCRIPTS
    jQuery.fn.extend({
        menuScroll: function (offset) {
            // Declare all global variables
            var topMenu = this;
            var topOffset = offset ? offset : 0;
            var menuItems = $(topMenu).find("a");
            var lastId;
            // Save all menu items into scrollItems array
            var scrollItems = $(menuItems).map(function () {
                var item = $($(this).attr("href"));
                if (item.length) {
                    return item;
                }
            });
            // When the menu item is clicked, get the #id from the href value, then scroll to the #id element
            $(topMenu).on("click", "a", function (e) {
                var href = $(this).attr("href");
                var offsetTop = href === "#" ? 0 : $(href).offset().top - topOffset;
                function checkWidth() {
                    var windowSize = $(window).width();
                    if (windowSize <= 767) {
                        $('html, body').stop().animate({
                            scrollTop: offsetTop - 200
                        }, 300);
                    }
                    else {
                        $('html, body').stop().animate({
                            scrollTop: offsetTop - 100
                        }, 300);
                    }
                }
                // Execute on load
                checkWidth();
                // Bind event listener
                $(window).resize(checkWidth);
                e.preventDefault();
            });
            // When page is scrolled
            $(window).scroll(function () {
                function checkWidth() {
                    var windowSize = $(window).width();
                    if (windowSize <= 767) {
                        var nm = $("html").scrollTop();
                        var nw = $("body").scrollTop();
                        var fromTop = (nm > nw ? nm : nw) + topOffset;
                        // When the page pass one #id section, return all passed sections to scrollItems and save them into new array current
                        var current = $(scrollItems).map(function () {
                            if ($(this).offset().top - 250 <= fromTop)
                                return this;
                        });
                        // Get the most recent passed section from current array
                        current = current[current.length - 1];
                        var id = current && current.length ? current[0].id : "";
                        if (lastId !== id) {
                            lastId = id;
                            // Set/remove active class
                            $(menuItems)
                                .parent().removeClass("active")
                                .end().filter("[href='#" + id + "']").parent().addClass("active");
                        }
                    }
                    else {
                        var nm = $("html").scrollTop();
                        var nw = $("body").scrollTop();
                        var fromTop = (nm > nw ? nm : nw) + topOffset;
                        // When the page pass one #id section, return all passed sections to scrollItems and save them into new array current
                        var current = $(scrollItems).map(function () {
                            if ($(this).offset().top <= fromTop)
                                return this;
                        });
                        // Get the most recent passed section from current array
                        current = current[current.length - 1];
                        var id = current && current.length ? current[0].id : "";
                        if (lastId !== id) {
                            lastId = id;
                            // Set/remove active class
                            $(menuItems)
                                .parent().removeClass("active")
                                .end().filter("[href='#" + id + "']").parent().addClass("active");
                        }
                    }
                }
                // Execute on load
                checkWidth();
                // Bind event listener
                $(window).resize(checkWidth);
            });
        }
    });
}


}); 

$(window).on('load resize orientationchange', function (e) {
    var header_height = $('header').outerHeight();
    $('header').next('.wrapper').css('margin-top', header_height + 'px');
});


